import { UserRole } from '@markant-platform/shared/user/model';
import {
  OrganizationDto,
  SubOrganizationData,
  SubOrganizationPathData,
} from '@markant-platform/shared/organization/model';
import {
  AssignedRole,
  CartridgeRoleAssignmentAggregation,
  CartridgeWithSelectableRoles,
  Role,
  SelectableRole,
  VariantRoleAssignmentLimit,
  VariantRoleAssignmentLimitResponse,
} from '@markant-platform/authorizer/model';

export const MOCK_USER_ROLES: UserRole[] = [
  {
    name: 'TEST_LEISTUNG_GROUP_ROLE_SUBORGANIZATION',
    id: 'b643c95a762f9b5182733e32',
    organizationId: '63a56f5a704b744a2995513a',
    leistungId: '1234e29544e9fd436c21be4f',
    localizedCartridgeName: 'Cartridge prototype',
    localizedDisplayName: 'Test-Role-Variant-ID for group in suborganization',
    localizedDescription:
      'A role for testing that uses an variant id and should be assigned to a group. Role should be limited to a suborganization.',
  } as UserRole,
  {
    name: 'TEST_LEISTUNG_ROLE_3',
    id: '63ef9415670c184735d14aec',
    organizationId: '63a56f5a704b744a2995513a',
    leistungId: '1234e29544e9fd436c21be4f',
    localizedCartridgeName: 'Cartridge prototype',
    localizedDisplayName: 'Test-Role 3',
    localizedDescription: 'A role for testing 3',
  } as UserRole,
];

export const MOCK_SUB_ORGANIZATIONS: SubOrganizationData[] = [
  {
    id: 'sub1',
    organizationId: 'org1',
    parentId: 'parent1',
    name: 'SubOrg1',
    childIds: ['child1', 'child2'],
    glns: [{ value: '1234567890123' }],
    status: 'ACTIVE',
    memberCount: 5,
    version: 1,
    path: [{ id: 'parent1', name: 'ParentOrg' }],
  },
  {
    id: 'sub2',
    organizationId: 'org2',
    parentId: 'parent2',
    name: 'SubOrg2',
    childIds: ['child3'],
    glns: [{ value: '2345678901234' }],
    status: 'DEACTIVATED',
    memberCount: 10,
    version: 2,
    path: [{ id: 'parent2', name: 'ParentOrg2' }],
  },
];

export const MOCK_CARTRIDGE_ROLES = [{ id: '1', name: 'Cartridge1', roles: [] }];

export const MOCK_SELECTABLE_ROLE: SelectableRole = {
  id: '7e1c562a-fdc2-4346-9819-d57d3a905d1d',
  internalName: 'DYNAMIC_ROLE_1',
  localizedDisplayName: 'Base',
  localizedDescription: 'Desctiption',
  cartridgeId: '4c124e3a-fc51-4772-a8c5-d20c37ced725',
  localizedServiceName: 'DVA',
  suborganizationData: [
    {
      id: 'sub-org-id-1',
      name: 'sub-org-1',
      selected: true,
    },
  ],
  selected: true,
  version: 1,
};

export const MOCK_ROLE: Role = {
  id: '7e1c562a-fdc2-4346-9819-d57d3a905d1d',
  internalName: 'DYNAMIC_ROLE_1',
  localizedDisplayName: 'Base',
  localizedDescription: 'Desctiption',
  cartridgeId: '4c124e3a-fc51-4772-a8c5-d20c37ced725',
  localizedServiceName: 'DVA',
  version: 1,
};

export const MOCK_PREVIOUS_CARTRIDGE_ROLE_ASSIGNMENTS: Record<string, UserRole[]> = {
  '4c124e3a-fc51-4772-a8c5-d20c37ced725': [
    {
      groupId: '26b56f5a704b744a2995852e',
      id: '4823c95a762f9b518273374c',
      leistungId: '1234e29544e9fd436c21be4f',
      localizedCartridgeName: 'Cartridge prototype',
      localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
      localizedDisplayName: 'Base',
      name: 'TEST_LEISTUNG_GROUP_ROLE',
      organizationId: '63a56f5a704b744a2995513a',
    } as UserRole,
  ],
};

export const MOCK_CARTRIDGE_WITH_SELECTABLE_ROLES_WITH_LIMITS: CartridgeWithSelectableRoles = {
  id: '1234e29544e9fd436c21be4f',
  name: 'Cartridge prototype',
  roles: [
    {
      id: '63ef9415670c184735d14adc',
      internalName: 'TEST_LEISTUNG_ROLE_4',
      localizedDisplayName: 'Test-Role 4',
      localizedDescription:
        'The description for test-role 4. This is a bit longer description to testing behavior by line changes.',
      cartridgeId: '1234e29544e9fd436c21be4f',
      localizedServiceName: 'Cartridge prototype',
      version: 1,
      selected: true,
      suborganizationData: [],
    },
  ],
  limits: {
    availableSlots: 1,
    limit: 2,
    allowsAssignment: true,
  },
};

export const MOCK_CARTRIDGE_WITH_SELECTABLE_ROLES: CartridgeWithSelectableRoles[] = [
  {
    id: 'cartridge-id-1',
    name: 'cartridge-1',
    roles: [
      {
        id: '7e1c562a-fdc2-4346-9819-d57d3a905d1d',
        internalName: 'DYNAMIC_ROLE_1',
        localizedDisplayName: 'Base',
        cartridgeId: '4c124e3a-fc51-4772-a8c5-d20c37ced725',
        localizedServiceName: 'DVA',
        suborganizationData: [
          {
            id: 'sub-org-id-1',
            name: 'sub-org-1',
            selected: true,
          },
        ],
        selected: true,
      } as SelectableRole,
    ],
  },
  {
    id: 'cartridge-id-2',
    name: 'cartridge-2',
    roles: [
      {
        id: 'd8975c0f-c6a0-4ffb-89c1-dc75e233d876',
        internalName: 'DYNAMIC_ROLE_2',
        localizedDisplayName: 'Partial',
        cartridgeId: '4c124e3a-fc51-4772-a8c5-d20c37ced725',
        localizedServiceName: 'DVA',
        suborganizationData: [
          {
            id: 'sub-org-id-1',
            name: 'sub-org-1',
            selected: true,
          },
        ],
        selected: true,
      } as SelectableRole,
    ],
  },
];

export const MOCK_VARIANT_ROLE_ASSIGNMENT_LIMIT_RESPONSE: VariantRoleAssignmentLimitResponse = {
  variantId: 'variant-id',
  organizationId: 'organization-id',
  availableServiceRoleAssignmentsLeft: 12,
  roleAssignmentLimit: 20,
};

export const MOCK_CARTRIDGE_ROLE_ASSIGNMENT_AGGREGATION: CartridgeRoleAssignmentAggregation = {
  rawRoles: [
    {
      id: '4823c95a762f9b518273374c',
      internalName: 'TEST_LEISTUNG_GROUP_ROLE',
      localizedDisplayName: 'Test-Role-Variant-ID for group',
      localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
      cartridgeId: '1234e29544e9fd436c21be4f',
      localizedServiceName: 'Cartridge prototype',
      version: 1,
    } as Role,
    {
      id: 'b643c95a762f9b5182733e32',
      internalName: 'TEST_LEISTUNG_GROUP_ROLE_SUBORGANIZATION',
      localizedDisplayName: 'Test-Role-Variant-ID for group in suborganization',
      localizedDescription:
        'A role for testing that uses an variant id and should be assigned to a group. Role should be limited to a suborganization.',
      cartridgeId: '1234e29544e9fd436c21be4f',
      localizedServiceName: 'Cartridge prototype',
      version: 1,
    } as Role,
  ],
  roleLimits: [
    {
      organizationId: '63a56f5a704b744a2995513a',
      variantId: '1234e29544e9fd436c21abcd',
      availableServiceRoleAssignmentsLeft: undefined,
      roleAssignmentLimit: undefined,
    } as VariantRoleAssignmentLimitResponse,
    {
      organizationId: '63a56f5a704b744a2995513a',
      variantId: '1234e29544e9fd436c21be4f',
      availableServiceRoleAssignmentsLeft: undefined,
      roleAssignmentLimit: undefined,
    } as VariantRoleAssignmentLimitResponse,
  ],
};

export const MOCK_ASSIGNED_ROLES: AssignedRole[] = [
  {
    role: {
      id: '4823c95a762f9b518273374c',
      internalName: 'TEST_LEISTUNG_GROUP_ROLE',
      localizedDisplayName: 'Test-Role-Variant-ID for group',
      localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
      cartridgeId: '1234e29544e9fd436c21be4f',
      localizedServiceName: 'Cartridge prototype',
      version: 1,
    } as Role,
    organization: {
      id: '63a56f5a704b744a2995513a',
      name: 'Super Testing GmbH',
    } as OrganizationDto,
  },
];

export const MOCK_AGGREGATE_GROUP_ROLE_ASSIGNMENT = [
  {
    id: '1234e29544e9fd436c21be4f',
    name: 'Cartridge prototype',
    roles: [
      {
        id: '4823c95a762f9b518273374c',
        internalName: 'TEST_LEISTUNG_GROUP_ROLE',
        localizedDisplayName: 'Test-Role-Variant-ID for group',
        localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
        cartridgeId: '1234e29544e9fd436c21be4f',
        localizedServiceName: 'Cartridge prototype',
        version: 1,
        selected: true,
        suborganizationData: [
          {
            id: 'sub123213org123123',
            name: 'Test Sub Org',
            selected: true,
          },
          {
            id: 'sub123213org123128',
            name: 'Test Sub Org 2',
            selected: true,
          },
        ],
      },
      {
        id: '4823c95a762f9b518273374c555555555',
        cartridgeId: '1234e29544e9fd436c21be4f',
        internalName: 'TEST_LEISTUNG_GROUP_ROLE',
        localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
        localizedDisplayName: 'Test-Role-Variant-ID for group',
        localizedServiceName: 'Cartridge prototype',
        selected: true,
        suborganizationData: [{ id: 'sub123213org123128', name: 'Test Sub Org 2', selected: true }],
        version: 1,
      },
    ],
    limits: { allowsAssignment: true },
  },
  {
    id: '1234e29544e9fd436c21be4f2',
    name: 'Cartridge prototype',
    roles: [
      {
        id: '4823c95a762f9b518273374d',
        internalName: 'TEST_LEISTUNG_GROUP_ROLE_1',
        localizedDisplayName: 'Test-Role-Variant-ID for group',
        localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
        cartridgeId: '1234e29544e9fd436c21be4f2',
        localizedServiceName: 'Cartridge prototype',
        version: 1,
        selected: true,
        suborganizationData: [],
      },
    ],
    limits: { allowsAssignment: true },
  },
];

export const MOCK_ASSIGNED_ROLES_DUPLICATE_CARTRIDGE: AssignedRole[] = [
  {
    role: {
      id: '4823c95a762f9b518273374c',
      internalName: 'TEST_LEISTUNG_GROUP_ROLE',
      localizedDisplayName: 'Test-Role-Variant-ID for group',
      localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
      cartridgeId: '1234e29544e9fd436c21be4f',
      localizedServiceName: 'Cartridge prototype',
      version: 1,
    } as Role,
    organization: {
      id: '63a56f5a704b744a2995513a',
      name: 'Super Testing GmbH',
    } as OrganizationDto,
    subOrganization: {
      id: 'sub123213org123123',
      name: 'Test Sub Org',
    } as SubOrganizationPathData,
  },
  {
    role: {
      id: '4823c95a762f9b518273374d',
      internalName: 'TEST_LEISTUNG_GROUP_ROLE_1',
      localizedDisplayName: 'Test-Role-Variant-ID for group',
      localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
      cartridgeId: '1234e29544e9fd436c21be4f2',
      localizedServiceName: 'Cartridge prototype',
      version: 1,
    } as Role,
    organization: {
      id: '63a56f5a704b744a2995513a',
      name: 'Super Testing GmbH',
    } as OrganizationDto,
  },
  {
    role: {
      id: '4823c95a762f9b518273374c',
      internalName: 'TEST_LEISTUNG_GROUP_ROLE',
      localizedDisplayName: 'Test-Role-Variant-ID for group',
      localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
      cartridgeId: '1234e29544e9fd436c21be4f',
      localizedServiceName: 'Cartridge prototype 3',
      version: 1,
    } as Role,
    organization: {
      id: '63a56f5a704b744a2995513a',
      name: 'Super Testing GmbH 3',
    } as OrganizationDto,
    subOrganization: {
      id: 'sub123213org123128',
      name: 'Test Sub Org 2',
    } as SubOrganizationPathData,
  },
  {
    role: {
      id: '4823c95a762f9b518273374c555555555',
      internalName: 'TEST_LEISTUNG_GROUP_ROLE',
      localizedDisplayName: 'Test-Role-Variant-ID for group',
      localizedDescription: 'A role for testing that uses an variant id and should be assigned to a group',
      cartridgeId: '1234e29544e9fd436c21be4f',
      localizedServiceName: 'Cartridge prototype',
      version: 1,
    } as Role,
    organization: {
      id: '63a56f5a704b744a2995513a',
      name: 'Super Testing GmbH 3',
    } as OrganizationDto,
    subOrganization: {
      id: 'sub123213org123128',
      name: 'Test Sub Org 2',
    } as SubOrganizationPathData,
  },
];

export const MOCK_VARIANT_ROLE_ASSIGNMENT_LIMITS: VariantRoleAssignmentLimitResponse[] = [
  {
    organizationId: 'org-1',
    variantId: 'var-1',
    availableServiceRoleAssignmentsLeft: 3,
    roleAssignmentLimit: 5,
  },
  {
    organizationId: 'org-1',
    variantId: 'var-2',
    availableServiceRoleAssignmentsLeft: 7,
    roleAssignmentLimit: 10,
  },
  {
    organizationId: 'org-1',
    variantId: 'var-3',
    availableServiceRoleAssignmentsLeft: 2,
    roleAssignmentLimit: 5,
  },
  {
    organizationId: 'org-1',
    variantId: 'var-4',
    availableServiceRoleAssignmentsLeft: 7,
    roleAssignmentLimit: 7,
  },
];

export const MOCK_VARIANT_ROLE_ASSIGNMENT_LIMIT_USER_WITH_ACCESS: VariantRoleAssignmentLimit = {
  availableSlots: 5,
  limit: 10,
  allowsAssignment: true,
  userHasAlreadyAssignmentForVariant: true,
};
